import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const Export = ({ ...otherProps }) => {
  return (
    <SvgIcon
      viewBox="0 0 17 16"
      sx={{ width: '17px', height: '16px', fill: 'none' }}
      {...otherProps}
    >
      <path
        d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
        stroke="#2C63E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 2H14V6" stroke="#2C63E5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.66675 9.33333L14.0001 2"
        stroke="#2C63E5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default Export
